import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [primaryColor, setPrimaryColor] = useState(() => {
        return localStorage.getItem('appPrimaryColor') || '#4a5568';
    });

    useEffect(() => {
        localStorage.setItem('appPrimaryColor', primaryColor);
    }, [primaryColor]);

    return (
        <ThemeContext.Provider value={{ primaryColor, setPrimaryColor }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useAppTheme = () => useContext(ThemeContext);
